var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { BILLING_ADDRESS_PREFIX, CUSTOMER_FIELD, MAIN_ADDRESS_PREFIX, } from './config/create_application_schema';
import { buildAddressFieldName, formatPhoneInput } from './config/form_field_factories';
import { resolveCountryAndState, toFormDate } from './customer_lookup_service';
import { asText, SUCCESS_STATUS_CODE } from './service_helpers';
var DOC_TYPE = {
    DriverLicense: 4,
    Invoice: 8,
};
export var AUTOFILL_SOURCE_KEY = {
    Invoice: 'invoiceSalesOrder',
    DriverLicense: 'driversLicense',
};
var SOURCES = (_a = {},
    _a[AUTOFILL_SOURCE_KEY.Invoice] = {
        endPoint: api_urls.OCR_DEALER_INVOICE,
        docType: DOC_TYPE.Invoice,
        label: 'Invoice/Sales Order',
    },
    _a[AUTOFILL_SOURCE_KEY.DriverLicense] = {
        endPoint: api_urls.OCR_DRIVER_LICENSE,
        docType: DOC_TYPE.DriverLicense,
        label: "Driver's License",
    },
    _a);
var ADDRESS_FIELD_SUFFIXES = [
    'Address',
    'Country',
    'City',
    'State',
    'PostalCode',
    'Email',
    'Phone',
];
var readAddress = function (address) {
    return typeof address === 'string' ? { streetAddress: address } : address !== null && address !== void 0 ? address : {};
};
var assign = function (values, name, value, labels, label) {
    if (!value) {
        return;
    }
    values[name] = value;
    labels.push(label);
};
var buildAutofillValues = function (data, isConsumerProgram) {
    var _a, _b;
    var customer = (_b = (_a = data.OcrExtractedData) === null || _a === void 0 ? void 0 : _a.CustomerData) !== null && _b !== void 0 ? _b : {};
    var address = readAddress(customer.Address);
    var _c = resolveCountryAndState(address.state), countryCode = _c.countryCode, stateCode = _c.stateCode;
    var values = {};
    var filledLabels = [];
    var mainField = function (suffix) { return buildAddressFieldName(MAIN_ADDRESS_PREFIX, suffix); };
    if (isConsumerProgram) {
        assign(values, CUSTOMER_FIELD.SignerFirstName, asText(customer.FirstName), filledLabels, 'First Name');
        assign(values, CUSTOMER_FIELD.SignerLastName, asText(customer.LastName), filledLabels, 'Last Name');
        assign(values, CUSTOMER_FIELD.DateOfBirth, toFormDate(customer.DateOfBirth), filledLabels, 'Date Of Birth');
    }
    else {
        var legalName = "".concat(asText(customer.FirstName), " ").concat(asText(customer.LastName)).trim();
        assign(values, CUSTOMER_FIELD.LegalRegisteredName, legalName, filledLabels, 'Legal Name');
    }
    assign(values, mainField('Address'), asText(address.streetAddress), filledLabels, 'Main Address');
    assign(values, mainField('City'), asText(address.city), filledLabels, 'City');
    assign(values, mainField('State'), stateCode, filledLabels, 'State');
    assign(values, mainField('Country'), countryCode, filledLabels, 'Country');
    assign(values, mainField('PostalCode'), asText(address.postalCode), filledLabels, 'Postal Code');
    assign(values, mainField('Email'), asText(customer.Email), filledLabels, 'Email');
    assign(values, mainField('Phone'), formatPhoneInput(asText(customer.PhoneNumber)), filledLabels, 'Phone Number');
    assign(values, CUSTOMER_FIELD.Country, countryCode, filledLabels, 'Country Of Incorporation');
    assign(values, CUSTOMER_FIELD.StateOfIncorporation, stateCode, filledLabels, 'State Of Incorporation');
    if (values[mainField('Address')]) {
        values[CUSTOMER_FIELD.BillingSameAsMain] = true;
        filledLabels.push('Billing Address');
        ADDRESS_FIELD_SUFFIXES.forEach(function (suffix) {
            var mainValue = values[buildAddressFieldName(MAIN_ADDRESS_PREFIX, suffix)];
            if (mainValue !== undefined) {
                values[buildAddressFieldName(BILLING_ADDRESS_PREFIX, suffix)] = mainValue;
            }
        });
    }
    return { values: values, filledLabels: filledLabels };
};
var buildFormData = function (file, docType, context) {
    var formData = new FormData();
    formData.append('File', file);
    formData.append('DocType', String(docType));
    var append = function (name, value) {
        if (value) {
            formData.append(name, value);
        }
    };
    append('ProgramAspireOId', context.programAspireOId);
    append('ProgramId', context.programId);
    append('SalesRepId', context.salesRepId);
    append('DealerAspireOId', context.dealerAspireOId);
    append('LocationAspireOId', context.locationAspireOId);
    append('ApplicationId', context.applicationId);
    append('ApplicationType', context.applicationType);
    return formData;
};
var postDocument = function (endPoint, formData) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, api_service.post({
                endPoint: endPoint,
                payLoad: formData,
                headerType: api_service.ContentHeaders.FormData,
                showLoader: false,
            })];
    });
}); };
export var uploadAutofillDocument = function (sourceKey, file, context, isConsumerProgram) {
    if (isConsumerProgram === void 0) { isConsumerProgram = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var source, response, data, _a, values, filledLabels, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    source = SOURCES[sourceKey];
                    if (!source) {
                        return [2, null];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4, postDocument(source.endPoint, buildFormData(file, source.docType, context))];
                case 2:
                    response = _c.sent();
                    if (((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.statusCode) !== SUCCESS_STATUS_CODE || !response.data.data) {
                        return [2, null];
                    }
                    data = response.data.data;
                    _a = buildAutofillValues(data, isConsumerProgram), values = _a.values, filledLabels = _a.filledLabels;
                    return [2, {
                            sourceKey: sourceKey,
                            documentLabel: source.label,
                            fileId: asText(data.Id),
                            fileName: asText(data.FileName) || file.name,
                            applicationId: asText(data.ApplicationId),
                            values: values,
                            filledLabels: filledLabels,
                        }];
                case 3:
                    error_1 = _c.sent();
                    return [2, null];
                case 4: return [2];
            }
        });
    });
};
export var deleteAutofillDocument = function (fileId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!fileId) {
                    return [2, true];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, api_service.delete({
                        endPoint: "".concat(api_urls.DELETE_DOCUMENT, "?FileId=").concat(encodeURIComponent(fileId)),
                        showLoader: false,
                    })];
            case 2:
                response = _b.sent();
                return [2, ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.statusCode) === SUCCESS_STATUS_CODE];
            case 3:
                error_2 = _b.sent();
                return [2, false];
            case 4: return [2];
        }
    });
}); };
